export const SCREENS = {
    SPLASH: 'splash',
    ONBOARDING: 'onboarding',
    LOGIN: 'login',
    SIGNUP: 'signup',
    PROFILE_SETUP: 'profileSetup',
    DISCOVER: 'discover',
    YAP_TAB: 'yaptab',
    EXPLORE: 'explore',
    CHAT: 'chat',
    PROFILE: 'profile',
    NOTIFICATIONS: 'notifications',
    SETTINGS: 'settings',
    SAFETY: 'safety',
    MODERATOR_DASHBOARD: 'moderatorDashboard',
    MY_BUSINESS: 'myBusiness',
    BUSINESS_PROFILE: 'businessProfile',
    YAP_DETAIL: 'yapDetail',
    FRIEND_PROFILE: 'friendProfile',
    EDIT_PROFILE: 'editProfile',
    COUNTRY_SELECTION: 'countrySelection',
    ALL_COUNTRIES: 'allCountries',
    ALL_TRIBES: 'allTribes',
    ALL_HISTORY: 'allHistory',
    ALL_FLAGS: 'allFlags',
    TRIBE_GROUP: 'tribeGroup',
    HISTORY_FORUM: 'historyForum',
    USER_YAPS: 'userYaps',
    FRIEND_YAPS: 'friendYaps',
    MATCHED_USER_PROFILE: 'matchedUserProfile',
    DIRECT_MESSAGE: 'directMessage',
    SHOUT_DETAIL: 'shoutDetail',
    REPORT: 'report',
    BLOCKED_USERS: 'blockedUsers',
    MUTED_WORDS: 'mutedWords',
    EVENT_DETAILS: 'eventDetails',
    STORE: 'store',
    ALL_FORUMS: 'allForums',
} as const;

export const EVENTS = {
    NAVIGATE_TO_ALL_COUNTRIES: 'navigateToAllCountries',
    NAVIGATE_TO_YAP_DETAIL: 'navigateToYapDetail',
    NAVIGATE_TO_FRIEND_PROFILE: 'navigateToFriendProfile',
    NAVIGATE_TO_EDIT_PROFILE: 'navigateToEditProfile',
    NAVIGATE_TO_FRIENDS_TAB: 'navigateToFriendsTab',
    NAVIGATE_TO_USER_YAPS: 'navigateToUserYaps',
    NAVIGATE_TO_TRIBE_GROUP: 'navigateToTribeGroup',
    NAVIGATE_TO_HISTORY_FORUM: 'navigateToHistoryForum',
    NAVIGATE_TO_SCREEN: 'navigateToScreen',
    NAVIGATE_TO_FRIEND_CHAT: 'navigateToFriendChat',
    NAVIGATE_TO_EXPLORE_IDENTITY: 'navigateToExploreIdentity',
    NAVIGATE_TO_DIRECT_MESSAGE: 'navigateToDirectMessage',
    NAVIGATE_TO_FRIEND_YAPS: 'navigateToFriendYaps',
    NAVIGATE_TO_SHOUT_DETAIL: 'navigateToShoutDetail',
    NAVIGATE_TO_YAP_SHOUTS: 'navigateToYapShouts',
    NAVIGATE_TO_ROOM: 'navigateToRoom',
    NAVIGATE_TO_REPORT: 'navigateToReport',
    NAVIGATE_TO_BLOCKED_USERS: 'navigateToBlockedUsers',
    NAVIGATE_TO_MUTED_WORDS: 'navigateToMutedWords',
    NAVIGATE_TO_ALL_TRIBES: 'navigateToAllTribes',
    NAVIGATE_TO_ALL_IDENTITIES: 'navigateToAllIdentities',
    NAVIGATE_TO_ALL_FLAGS: 'navigateToAllFlags',
    NAVIGATE_TO_COUNTRY_SELECTION: 'navigateToCountrySelection',
    SHOW_MATCH_POPUP: 'showMatchPopup',
    NAVIGATE_TO_EVENT_DETAILS: 'navigateToDetails',
    SET_LOADING: 'setLoading',
    SHOW_INVITE_MODAL: 'showInviteModal',
    REAL_TIME_SLAP: 'realTimeSlap',
    NAVIGATE_TO_BUSINESS_PROFILE: 'navigateToBusinessProfile',
    NAVIGATE_TO_MY_BUSINESS: 'navigateToMyBusiness',
} as const;

export type ScreenName = typeof SCREENS[keyof typeof SCREENS];
export type NavigationEvent = typeof EVENTS[keyof typeof EVENTS];
